import React, { useState, useEffect } from "react";
import {
  Container,
  TextField,
  Button,
  Typography,
  Box,
  Alert,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import instance from "../utils/axiosInstance";

const Register = ({ user, setUser }) => {
  const [step, setStep] = useState(1); // 1: 이메일 입력, 2: 인증 코드 확인, 3: 회원가입
  const [email, setEmail] = useState("");
  const [verificationCode, setVerificationCode] = useState("");
  const [name, setName] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [message, setMessage] = useState("");

  const navigate = useNavigate();

  //테스트용 인증 스킵
  const skipVerification = true;

  useEffect(() => {
    instance
      .get("/user/me", { withCredentials: true })
      .then((res) => {
        setUser(res.data.user);
        navigate("/profile");
      })
      .catch(() => {
        setUser(null);
      });
  }, [user, setUser, navigate]);

  const requestVerificationCode = async () => {
    if (skipVerification) {
      setStep(3); // 🔥 바로 회원가입 단계로 이동
      setMessage("임시 모드: 인증 없이 진행합니다.");
      setError("");
      return;
    }

    try {
      await instance.post("/user/request-verification", { email });
      setMessage("인증 코드가 이메일로 전송되었습니다.");
      setError("");
      setStep(2);
    } catch (error) {
      setError(error.response?.data?.message || "인증 코드 요청 실패");
    }
  };

  const verifyCode = async () => {
    if (skipVerification) {
      setStep(3); // 🔥 인증 스킵
      setMessage("임시 모드: 인증 없이 진행합니다.");
      setError("");
      return;
    }

    try {
      const res = await instance.post("/user/verify-code", {
        email,
        code: verificationCode,
      });
      if (res.data.success) {
        setMessage("인증 성공! 회원가입을 진행하세요.");
        setError("");
        setStep(3);
      }
    } catch (error) {
      setError(error.response?.data?.message || "인증 실패");
    }
  };

  const registerUser = async () => {
    try {
      await instance.post("/user/register", { name, email, password });
      setMessage("회원가입 성공! 로그인 해주세요.");
      setError("");
      setTimeout(() => {
        navigate("/login");
      }, 2000);
    } catch (error) {
      setError(error.response?.data?.message || "회원가입 실패");
    }
  };

  return (
    <Container
      maxWidth="sm"
      sx={{
        mt: 10,
        px: 4,
        py: 6,
        bgcolor: "background.paper",
        borderRadius: 2,
        boxShadow: "0 0 10px rgba(0,0,0,0.1)",
      }}
    >
      <Typography variant="h4" fontWeight="bold" gutterBottom color="text.primary">
        회원가입
      </Typography>

      {message && (
        <Alert severity="success" sx={{ mb: 2 }}>
          {message}
        </Alert>
      )}
      {error && (
        <Alert severity="error" sx={{ mb: 2 }}>
          {error}
        </Alert>
      )}

      {/* 단계별 폼 */}
      {step === 1 && (
        <>
          <TextField
            label="이메일"
            fullWidth
            margin="normal"
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />
          <Button variant="contained" fullWidth sx={{ mt: 2 }} onClick={requestVerificationCode}>
            인증 코드 요청
          </Button>
          <Button
            variant="outlined"
            fullWidth
            sx={{ mt: 2 }}
            onClick={() => navigate("/metamask-register")}
          >
            메타마스크로 회원가입
          </Button>
        </>
      )}

      {step === 2 && (
        <>
          <TextField
            label="인증 코드"
            fullWidth
            margin="normal"
            value={verificationCode}
            onChange={(e) => setVerificationCode(e.target.value)}
            required
          />
          <Button variant="contained" fullWidth sx={{ mt: 2 }} onClick={verifyCode}>
            인증 코드 확인
          </Button>
        </>
      )}

      {step === 3 && (
        <>
          <TextField
            label="이름"
            fullWidth
            margin="normal"
            value={name}
            onChange={(e) => setName(e.target.value)}
            required
          />
          <TextField
            label="비밀번호"
            type="password"
            fullWidth
            margin="normal"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
          />
          <Button variant="contained" fullWidth sx={{ mt: 2 }} onClick={registerUser}>
            회원가입 완료
          </Button>
        </>
      )}

      {/* 다시 시작 버튼 */}
      {step !== 1 && (
        <Box sx={{ mt: 2 }}>
          <Button fullWidth variant="text" onClick={() => setStep(1)}>
            처음부터 다시 입력
          </Button>
        </Box>
      )}
    </Container>
  );
};

export default Register;
